import type { Option } from '@branchjs/neo-components';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_CHANNEL = 'UPDATE_QR_CODE_LINK_CHANNEL' as const;

export const updateQrCodeLinkChannel = (channel: Option) => ({
  data: { channel },
  type: UPDATE_QR_CODE_LINK_CHANNEL,
});

export type UpdateQrCodeLinkChannelResponseAction = DataAction<typeof UPDATE_QR_CODE_LINK_CHANNEL, { channel: Option }>;
